import React from 'react';
import { Button } from '@/components/ui/button';
import { motion } from 'framer-motion';
import { RefreshCcw, Home, AlertCircle, Coffee } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Error500() {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6 text-center">
      <div className="max-w-md w-full space-y-8">
        <div className="relative flex justify-center">
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="h-32 w-32 bg-destructive/10 rounded-full flex items-center justify-center"
          >
            <Coffee className="h-16 w-16 text-destructive animate-bounce" />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.3 }}
            className="absolute -top-2 -right-2"
          >
            <AlertCircle className="h-8 w-8 text-destructive fill-destructive/20" />
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="space-y-3"
        >
          <h1 className="text-4xl font-extrabold tracking-tight sm:text-5xl text-foreground">
            Erro 500
          </h1>
          <h2 className="text-2xl font-bold text-muted-foreground">
            Ops! O café derramou no nosso sistema.
          </h2>
          <p className="text-muted-foreground leading-relaxed">
            Parece que algo quebrou por aqui enquanto carregávamos seus dados.
            Não se preocupe, seus livros estão salvos! Tente recarregar a página.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="flex flex-col sm:flex-row gap-4 justify-center"
        >
          <Button 
            size="lg" 
            onClick={handleRefresh}
            className="text-lg px-8 gap-2"
          >
            <RefreshCcw className="h-5 w-5" />
            Recarregar Página
          </Button>
          <Button 
            variant="outline" 
            size="lg" 
            asChild 
            className="text-lg px-8 gap-2"
          >
            <Link to="/">
              <Home className="h-5 w-5" />
              Início
            </Link>
          </Button>
        </motion.div>

        <motion.p 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.7 }}
          className="text-sm text-muted-foreground pt-4 border-t"
        >
          Se o problema persistir, entre em contato com o suporte técnico.
        </motion.p>
      </div>
    </div>
  );
}
